import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36347a2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "boardSearcher" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "hidden" }, "게시판 검색", -1))
const _hoisted_3 = { class: "board-searcher" }
const _hoisted_4 = { class: "period-wrap" }
const _hoisted_5 = {
  key: 0,
  class: "calendar-dim"
}

import { onBeforeMount, ref } from 'vue';
import PeriodSelector from './PeriodSelector.vue';
import CalendarPicker from './CalendarPicker.vue';
import SearchBar from './SearchBar.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'BoardSearcher',
  props: {
  searchTypes: {
    type: Array,
    required: true,
  },
},
  emits: ['setDates', 'onClick_searchButton', 'setStateOption', 'setPeriodOption', 'setSearchType'],
  setup(__props, { emit }) {

const props = __props;



/**** data -------------------- */
var isOn_calendarDim = ref(false);
/**** methods ----------------- */
const setDates = (start: string, end: string) => {
  emit('setDates', start, end);
};
const onClick_searchButton = (word: string) => {
  emit('onClick_searchButton', word);
};
const setSearchType = (item: { code: string; name: string }) => {
  emit('setSearchType', item);
};
const setPeriodOption = (item: { code: string; name: string }) => {
  if (item.code === null || item.code === '00') {
    isOn_calendarDim.value = false;
  } else {
    isOn_calendarDim.value = true;
  }
  emit('setPeriodOption', item);
};
/**** content -----------------
 *
 * 게시판 검색
 * /
 * /
/**** hook -------------------- */

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(PeriodSelector, {
          class: "mb10",
          onSetPeriodOption: setPeriodOption
        }),
        _createVNode(CalendarPicker, { onSetDates: setDates }),
        _createVNode(_Transition, { name: "calendarDim" }, {
          default: _withCtx(() => [
            (_unref(isOn_calendarDim))
              ? (_openBlock(), _createElementBlock("div", _hoisted_5))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _createVNode(SearchBar, {
        "search-types": props.searchTypes,
        onOnClick_searchButton: onClick_searchButton,
        onSetSearchType: setSearchType
      }, null, 8, ["search-types"])
    ])
  ]))
}
}

})